<template>
  <div
    :id="id"
    class="mini-map" />
</template>

<script>
import { mapGetters } from "vuex";
import d3 from "@/plugins/d3";

const props = {
  district: {
    type: Number,
    required: true,
  },
  districtType: {
    type: String,
    required: true,
  },
  state: {
    type: String,
    required: true,
  },
};

const computed = {
  ...mapGetters(["numOfCandidateByDefault", "showMoreCandidates", "topojson", "fips"]),
  id() {
    return `mini-map`;
  },
  stateFips() {
    const FIPS_MAP = {
      61: "28",
      60: "27",
    };
    let fips = this.fips.state[this.state];
    if (fips in FIPS_MAP) {
      fips = FIPS_MAP[fips];
    }
    return fips;
  },
  geojson() {
    return this.topojson(this.districtType, this.state)();
  },
  projection() {
    return this.stateFips && this.stateFips !== "00" ? d3.geoMercator() : d3.geoAlbersUsa();
  },
  propsKey() {
    const key = {
      cd: "CD116FP",
      sldl: "SLDLST",
      sldu: "SLDUST",
    };
    return key[this.districtType];
  },
  allProps() {
    return Object.values(this.$props).join();
  },
};
const methods = {
  drawMap() {
    const self = this;
    const svgId = `${self.id}-svg`;
    let width = 80;
    let height = 50;

    const map = d3.select(`#${self.id}`);
    map.selectAll("g").remove();
    map.selectAll("svg").remove();
    // currently need a district number to draw until we upgrade to geoids - MA, NH, etc
    if (!this.district) return;
    const svg = map.append("svg").attr("width", width).attr("height", height).attr("id", svgId);
    let projection = self.projection.fitSize([width, height], self.geojson);
    let path = d3.geoPath().projection(projection);
    self.g = svg.append("g").attr("id", "mini-map-path");
    self.g
      .selectAll("path")
      .data(self.geojson.features)
      .enter()
      .append("path")
      .attr("d", path)
      .attr("stroke-width", 0.2)
      .attr("stroke", (d) => {
        return parseInt(d.properties[this.propsKey], 10) === self.district ? "black" : "#e0e0e0";
      })
      .style("fill", (d) => {
        return parseInt(d.properties[this.propsKey], 10) === self.district ? "black" : "#e0e0e0";
      });
    d3.select("#mini-map-path").attr("transform", function () {
      const stateWidth = d3.select(this).node().getBBox().width;
      const stateHeight = d3.select(this).node().getBBox().height;
      return `translate(${width / 2 - stateWidth / 2}, ${height / 2 - stateHeight / 2})`;
    });
  },
};

const watch = {
  allProps() {
    this.drawMap();
  },
};

export default {
  props,
  data() {
    return {
      g: null,
    };
  },
  computed,
  watch,
  mounted() {
    this.drawMap();
  },
  methods,
};
</script>

<style>
.mini-map {
  display: flex;
  align-items: center;
  pointer-events: none;
}
</style>
